import { motion } from "framer-motion";
import { useReveal } from "@/lib/motion";
import { AutoScroller } from "@/components/AutoScroller";
import { SERVICE_GALLERY } from "@/lib/siteData";

// Continuous horizontal scrolling rail of brand cards at the bottom of each service page.
export const ServiceGallery = () => {
    const reveal = useReveal();

    return (
        <section className="relative overflow-hidden bg-brand py-16 md:py-24">
            <motion.div {...reveal()}>
                <AutoScroller ariaLabel="Galeria de serviços e projetos da Rock Fox">
                    {SERVICE_GALLERY.map((item) => (
                        <div
                            key={item.id}
                            className="aspect-[4/5] w-[230px] sm:w-[270px] md:w-[310px] lg:w-[330px] shrink-0 overflow-hidden rounded-[26px] md:rounded-[30px] bg-slot shadow-lg transition-transform duration-300 hover:scale-[1.03]"
                        >
                            <img
                                src={item.src}
                                alt={item.alt}
                                className="h-full w-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    ))}
                </AutoScroller>
            </motion.div>
        </section>
    );
};
